export default "/images/736bacf7af3ed4ce6d31e45379bbb243.avif";